import React, { Fragment } from 'react'

import TriggerCallsLoader from './_load/TriggerCallsLoader'
import TriggerCallsTable from './table/TriggerCallsTable'

const TriggerCallsList = () => {
  return (
    <Fragment>
      <TriggerCallsLoader>
        <TriggerCallsTable />
      </TriggerCallsLoader>
    </Fragment>
  )
}

export default TriggerCallsList
